import { Navigate, Outlet } from 'react-router-dom'
const PrivateRoutes = () => {
  let auth = localStorage.getItem('userCredential');
return (
    auth ? <Outlet/> : <Navigate to='/login' replace/>
  )
}

export default PrivateRoutes